import { apiClient } from './api'

export type IntakeStatus = 'submitted' | 'under_review' | 'approved' | 'rejected' | 'deferred' | 'converted'

export interface IntakeRequest {
  id: number
  title: string
  description: string | null
  business_case: string | null
  requested_by: number | null
  sponsor: string | null
  portfolio_id: number | null
  estimated_cost: number | null
  estimated_weeks: number | null
  target_start: string | null
  status: IntakeStatus
  scores: Record<string, number>
  score: number | null
  rank: number | null
  decision_note: string | null
  decided_by: number | null
  decided_at: string | null
  project_id: number | null
  created_at: string | null
}

export interface IntakeList {
  requests: IntakeRequest[]
  weights: Record<string, number>
  criteria: string[]
  reversed: string[]
}

export const CRITERION_LABEL: Record<string, string> = {
  value: 'Value', strategic_fit: 'Strategic fit', urgency: 'Urgency', risk: 'Risk', effort: 'Effort',
}

export interface IntakeSubmit {
  title: string
  description?: string
  business_case?: string
  sponsor?: string
  portfolio_id?: number
  estimated_cost?: number
  estimated_weeks?: number
  target_start?: string
}

/** Project intake — backend/app/api/v1/endpoints/intake.py */
export const intakeService = {
  async list(status?: IntakeStatus): Promise<IntakeList> {
    const { data } = await apiClient.get<IntakeList>('/api/v1/intake/requests', { params: status ? { status } : {} })
    return data
  },
  async submit(body: IntakeSubmit): Promise<IntakeRequest> {
    const { data } = await apiClient.post<IntakeRequest>('/api/v1/intake/requests', body)
    return data
  },
  async score(id: number, scores: Record<string, number>): Promise<IntakeRequest> {
    const { data } = await apiClient.put<IntakeRequest>(`/api/v1/intake/requests/${id}/scores`, { scores })
    return data
  },
  async decide(id: number, decision: 'approved' | 'rejected' | 'deferred', note?: string): Promise<IntakeRequest> {
    const { data } = await apiClient.post<IntakeRequest>(`/api/v1/intake/requests/${id}/decision`, { decision, note })
    return data
  },
  async convert(id: number): Promise<IntakeRequest & { project_id: number }> {
    const { data } = await apiClient.post(`/api/v1/intake/requests/${id}/convert`)
    return data
  },
  async setWeights(weights: Record<string, number>): Promise<{ weights: Record<string, number> }> {
    const { data } = await apiClient.put('/api/v1/intake/weights', { weights })
    return data
  },
}
